/*
 * HomeConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

// export const ON_CALL_UPLOAD = 'boilerplate/Landing/ON_CALL_UPLOAD'
export const LOADER_STATUS = "DATA_ANALYTICS/LOADER_STATUS";
export const PROFILE_INFO = "DATA_ANALYTICS/PROFILE_INFO";
export const SET_VARIANCE_DATA = "CREDITNOTE/SET_VARIANCE_DATA";
export const SET_CREDIT_NOTE_DATA = "CREDITNOTE/SET_CREDIT_NOTE_DATA";
export const SET_CREDIT_NOTE_ANALYSIS_DATA =
  "CREDITNOTE/SET_CREDIT_NOTE_ANALYSIS_DATA";

export const SET_VENDOR_LIST = "CREDITNOTE/SET_VENDOR_LIST";
export const SET_RET_PERIOD = "CREDITNOTE/SET_RET_PERIOD";
export const SET_INVOICE_COUNT = "CREDITNOTE/SET_INVOICE_COUNT";
export const SET_CLEAR_GRAPH = "CREDITNOTE/SET_CLEAR_GRAPH";
